import React from 'react';
import styled from 'styled-components';

const StyledBox = styled.div<Props>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background: ${({ theme, isValid }) => (isValid ? '#80e0a6' : theme.colors.primary)};
  height: 43px;
  align-items: center;
  padding: 0 1.125rem;
  color: #000;
  border-top-left-radius: ${({ theme }) => theme.misc.buttonBorderRadius};
  border-top-right-radius: ${({ theme }) => theme.misc.buttonBorderRadius};
`;

interface Props {
  isValid?: boolean;
}

export const BoxHeader: React.FC<Props & React.HtmlHTMLAttributes<HTMLDivElement>> = (
  props: any,
) => {
  return <StyledBox {...props} />;
};
